<template>
  <div class="bro Page-Content flex-contents">
  
    <div style="width: 100%;height: 100%;position: absolute;top: 0;">
      <swiper class="swiper swiperbottoms" :options="swiperOption" ref="swiperOption" >
        <swiper-slide  v-for="item,i in 27" :key="i">
          <img ondragstart="return false;" :src="require(`../assets/Brochure/${padZero(i,2)}.png`)" alt="">
          <!-- <img ondragstart="return false;" src="../assets/Brochure/00.png" alt=""> -->
        </swiper-slide>
      </swiper>

      <swiper class="swiper swipertop" :options="swiperOptionBottom" ref="swiperOptionBottom" >
        <swiper-slide  v-for="item,i in 25" :key="i" >
          <img ondragstart="return false;" :src="require(`../assets/Brochure/${padZero(i,2)}.png`)" alt="" @click="handleSlideClick(i)">
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-button-prev" style="left: 5%;top: 45%;"><img src="@/assets/btn/left1.png" alt=""></div>
    <div class="swiper-button-next" style="right:5%;top: 45%;"><img src="@/assets/btn/right1.png" alt=""></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOptionBottom:{
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 7,
        loopedSlides: 4, // looped slides should be the same
        // loop:true,
        spaceBetween: 10, 
        centeredSlides : true,
        // direction: 'vertical',
      },
      swiperOption: {
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 4, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides : true,
        // loop:true,
        // autoplay: {
        //     delay: 3000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
        },

        },
        nowdata:[
          {name:"A",type:"img",url:require("@/assets/Brochure/01.png")},

        ],
    }
  },
  methods:{
    handleSlideClick(index) {
      // 切换到指定索引的 slide
      console.log(index);
      this.$refs.swiperOptionBottom.swiper.slideTo(index);
    },
    padZero(num, length) {
    return String(num).padStart(length, '0');
    }
  },
  mounted(){
    this.$nextTick(()=>{
      const top = this.$refs.swiperOption.swiper
      const bottom = this.$refs.swiperOptionBottom.swiper
      top.controller.control = bottom
      bottom.controller.control = top
    })
  }
}
</script>

<style lang="less">

 
.bro{
  // height: 90%;
  position: relative;
  overflow: hidden;
.swiperbottoms{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 84%;
  // border-radius: 10px;
  .swiper-slide{
    img{
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
  }
}
.swipertop{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 15%;
  // border-radius: 10px;
  .swiper-slide{
    img{
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
  }
}
.swiper-slide{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    // border-radius: 10px;
    // background-color: #000000;
}
.swiper-button-prev,.swiper-button-next{
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  img{
    max-height: 5rem;
    max-width: 5rem;
  }
}


}

</style>

